export const config = {
  MOBILE_WIDTH: 767,
};
